import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { BazaWebUtilSharedService, MktSectionCommonFields, UtilModule } from '@scaliolabs/baza-web-utils';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzGridModule } from 'ng-zorro-antd/grid';

@Component({
    selector: 'app-hero',
    templateUrl: './hero.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, UtilModule, NzGridModule, NzButtonModule],
})
export class HeroComponent extends MktSectionCommonFields {
    @Input()
    index = 0;

    @Input()
    btnClass = 'ant-btn-primary';

    constructor(public readonly wts: BazaWebUtilSharedService, private readonly cdr: ChangeDetectorRef) {
        super();
    }

    public get i18nBasePath() {
        return `uic.marketing.hero.section${this.index}`;
    }
}
